var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIncomingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72419 8.68964C7.72419 8.1564 7.90756 7.72412 8.59316 7.72412H24.2345C24.9201 7.72412 25.1035 8.1564 25.1035 8.68964C25.1035 9.22288 24.9201 9.65516 24.2345 9.65516H8.59316C7.90756 9.65516 7.72419 9.22288 7.72419 8.68964Z",
    fill: "#232360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72419 20.2758C7.72419 19.7426 7.90756 19.3103 8.59316 19.3103H24.2345C24.9201 19.3103 25.1035 19.7426 25.1035 20.2758C25.1035 20.8091 24.9201 21.2414 24.2345 21.2414H8.59316C7.90756 21.2414 7.72419 20.8091 7.72419 20.2758Z",
    fill: "#232360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72419 14.4827C7.72419 13.9495 7.90756 13.5172 8.59316 13.5172H24.2345C24.9201 13.5172 25.1035 13.9495 25.1035 14.4827C25.1035 15.016 24.9201 15.4483 24.2345 15.4483H8.59316C7.90756 15.4483 7.72419 15.016 7.72419 14.4827Z",
    fill: "#232360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82764 20.2758C4.82764 20.809 4.39536 21.2413 3.86212 21.2413C3.32888 21.2413 2.89661 20.809 2.89661 20.2758C2.89661 19.7425 3.32888 19.3102 3.86212 19.3102C4.39536 19.3102 4.82764 19.7425 4.82764 20.2758Z",
    fill: "#232360"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82764 14.4827C4.82764 15.0159 4.39536 15.4482 3.86212 15.4482C3.32888 15.4482 2.89661 15.0159 2.89661 14.4827C2.89661 13.9495 3.32888 13.5172 3.86212 13.5172C4.39536 13.5172 4.82764 13.9495 4.82764 14.4827Z",
    fill: "#232360"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82764 8.68964C4.82764 9.22288 4.39536 9.65516 3.86212 9.65516C3.32888 9.65516 2.89661 9.22288 2.89661 8.68964C2.89661 8.1564 3.32888 7.72412 3.86212 7.72412C4.39536 7.72412 4.82764 8.1564 4.82764 8.68964Z",
    fill: "#232360"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingIcon);
export default __webpack_public_path__ + "static/media/incoming-icon.8890cb5dff526bb48376214713183a37.svg";
export { ForwardRef as ReactComponent };